import { gql } from '@apollo/client'

export const USER_GROUP = gql`
  fragment UserGroup on UserGroup {
    id
    name
    description
    type
  }
`
